import { useTranslation } from 'react-i18next';
import { useState } from "react";



const dealerships = [
  { id: 1, src: "/images/bayilikler/abb.jpg", alt: "ABB" },
  { id: 2, src: "/images/bayilikler/armas.jpg", alt: "Armaş" },
  { id: 3, src: "/images/bayilikler/baylan.jpg", alt: "Baylan" },
  { id: 4, src: "/images/bayilikler/ecesan.jpg", alt: "Ecesan" },
  { id: 5, src: "/images/bayilikler/fluke.jpg", alt: "Fluke" },
  { id: 6, src: "/images/bayilikler/isonem.jpg", alt: "Isonem" },
  { id: 7, src: "/images/bayilikler/kalekim.jpg", alt: "Kalekim" },
  { id: 8, src: "/images/bayilikler/karbon.jpg", alt: "Karbon" },
  { id: 9, src: "/images/bayilikler/makel.jpg", alt: "Makel" },
  { id: 10, src: "/images/bayilikler/metoba.jpg", alt: "Metoba" },
  { id: 11, src: "/images/bayilikler/optimum.jpg", alt: "Optimum" },
  { id: 12, src: "/images/bayilikler/pelsan.jpg", alt: "Pelsan" },
  { id: 13, src: "/images/bayilikler/pimtas.jpg", alt: "Pimtaş" },
  { id: 14, src: "/images/bayilikler/polisan.jpg", alt: "Polisan" },
  { id: 15, src: "/images/bayilikler/selsil.jpg", alt: "Selsil" },
  { id: 16, src: "/images/bayilikler/sista.jpg", alt: "Sista" },
  { id: 17, src: "/images/bayilikler/viko.jpg", alt: "Viko" },
  { id: 18, src: "/images/bayilikler/vitra.jpg", alt: "Vitra" },
  { id: 19, src: "/images/bayilikler/yaparlar.jpg", alt: "Yaparlar" },
  { id: 20, src: "/images/bayilikler/yds.jpg", alt: "YDS" },
  { id: 21, src: "/images/bayilikler/alarko.jpg", alt: "Alarko" },
  { id: 22, src: "/images/bayilikler/askaynak.jpg", alt: "Askaynak" },
  { id: 23, src: "/images/bayilikler/ayvaz.jpg", alt: "Ayvaz" },
  { id: 25, src: "/images/bayilikler/beybi.jpg", alt: "Beybi" },
  { id: 26, src: "/images/bayilikler/bmex.jpg", alt: "BMEX" },
  { id: 27, src: "/images/bayilikler/bonuspan.jpg", alt: "Bonuspan" },
  { id: 28, src: "/images/bayilikler/bosh.jpg", alt: "Bosch" },
  { id: 29, src: "/images/bayilikler/cayirva.jpg", alt: "Çayırva" },
  { id: 30, src: "/images/bayilikler/dekor.jpg", alt: "Dekor" },
  { id: 31, src: "/images/bayilikler/dewalt.jpg", alt: "Dewalt" },
  { id: 32, src: "/images/bayilikler/duyar.jpg", alt: "Duyar" },
  { id: 33, src: "/images/bayilikler/ebitt.jpg", alt: "Ebitt" },
  { id: 34, src: "/images/bayilikler/eca.jpg", alt: "Eca" },
  { id: 36, src: "/images/bayilikler/feica.jpg", alt: "Feica" },
  { id: 37, src: "/images/bayilikler/firat.jpg", alt: "Fırat" },
  { id: 38, src: "/images/bayilikler/honey.jpg", alt: "Honeywell" },
  { id: 39, src: "/images/bayilikler/kale.jpg", alt: "Kale" },
  { id: 41, src: "/images/bayilikler/knipex.jpg", alt: "Knipex" },
  { id: 42, src: "/images/bayilikler/kose.jpg", alt: "Köse" },
  { id: 45, src: "/images/bayilikler/metresan.jpg", alt: "Metresan" },
  { id: 46, src: "/images/bayilikler/marshall.png", alt: "Marshall" },

  // Klasörde duran, listeye daha önce eklenmemiş markalar
  { id: 47, src: "/images/bayilikler/stanley.jpg", alt: "Stanley" },
  { id: 48, src: "/images/bayilikler/tekno.jpg", alt: "Tekno" },
  { id: 49, src: "/images/bayilikler/turkuaz.jpg", alt: "Turkuaz" },
  { id: 50, src: "/images/bayilikler/pakkens.jpg", alt: "Pakkens" },
  { id: 51, src: "/images/bayilikler/rothenberg.jpg", alt: "Rothenberg" },
  { id: 52, src: "/images/bayilikler/sonneflex.jpg", alt: "Sonneflex" },
  { id: 53, src: "/images/bayilikler/sumak.jpg", alt: "Sumak" },
  { id: 54, src: "/images/bayilikler/yalteks.jpg", alt: "Yalteks" },
];

const Bayilikler = () => {
  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState(null);

  return (
    <>
      <section className="container-page section">
        <div className="page-head">
          <h1 className="page-title">{t("dealershipsPage.title")}</h1>
          <p className="page-sub">{t("dealershipsPage.subtitle")}</p>
        </div>

        {/* Logo ızgarası — tek çizgi sistemi, gölgesiz */}
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {dealerships.map((bayi) => (
            <button
              key={bayi.id}
              onClick={() => setActiveImage(bayi.src)}
              className="flex h-32 items-center justify-center bg-white p-6 transition-colors duration-200 hover:bg-canvas"
            >
              <img
                src={bayi.src}
                alt={
                  t(`dealershipsPage.brands.${bayi.alt.toLowerCase()}`) ||
                  bayi.alt
                }
                loading="lazy"
                className="max-h-full max-w-full object-contain opacity-80 transition-opacity duration-200 hover:opacity-100"
              />
            </button>
          ))}
        </div>
      </section>

      {/* 🔍 IMAGE MODAL */}
      {activeImage && (
        <div onClick={() => setActiveImage(null)} className="overlay">
          <img
            src={activeImage}
            alt={t("ui.dealerLogoAlt")}
            className="max-h-[80vh] max-w-full animate-zoomIn rounded-lg bg-white p-8"
          />
        </div>
      )}
    </>
  );
};

export default Bayilikler;